import LoopWinsMediator from "ags/mediators/loop-wins-mediator";

export default class Mediators {
    public static LoopWinsMediatorType = LoopWinsMediator;
}
